import axios from "axios";
import baseURL from "./../api";
class DashboardService {
  constructor() {
    this.time = new Date().getTime();
}
    getTransactions() {
        return axios.get(`${baseURL}/transaction/summary?${this.time}`);
    }

    getTransactionsList(filterData,pageNumber, rowsPage, status) {
        filterData.userId = '';
        let formattedStartDate = '';
        let formattedEndDate = '';
        let paymentType = '';
        let paymentStatus = ''
        if(filterData.merchantID == '') {
          filterData.userId = filterData.agentID
        }
        if(filterData.agentID == '') {
          filterData.userId = filterData.merchantID
        }
        if(filterData.start_date) {
          const startDate = filterData.start_date; 
          const parts = startDate.split('-');
          formattedStartDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        if(filterData.end_date) {
          const startDate = filterData.end_date; 
          const parts = startDate.split('-');
          formattedEndDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        if(filterData.paymentType) {
          paymentType = filterData.paymentType.toUpperCase();
        }
        if(filterData.status) {
          paymentStatus = filterData.status;
        }
        
        
        return axios.get(`${baseURL}/transaction/history?fromDate=${formattedStartDate}&toDate=${formattedEndDate}&transactionType=${paymentType}&userId=${filterData.userId}&page=${pageNumber}&size=${rowsPage}&status=${paymentStatus}`);
    }

    getTransactionDetail(id) {
        return axios.get(`${baseURL}/transaction/${id}?${this.time}`);
    }

    confirmTransaction(id, data) {
        return axios.post(`${baseURL}/transaction/${id}/confirm?${this.time}`, data);
    }

    getTransactionsListAdmin() {
        return axios.get(`${baseURL}/admin/transactions?${this.time}`);
    }

    getTransactionTracker(id) {
        return axios.get(`${baseURL}/tracker/transaction/${id}?${this.time}`);
    }
    getCommissionDetails(id) {
        return axios.get(`${baseURL}/commission/${id}?${this.time}`);

    }
    raisedTransaction(id, data) {
        return axios.post(`${baseURL}/transaction/${id}/raise?${this.time}`, data);
    }

    getCount() {
      return axios.get(`${baseURL}/transaction/count?${this.time}`);

  }
  getSystemAnalysis() {
    return axios.get(`${baseURL}/config/system/analysis?${this.time}`);

}
getRaisedTransactions(filterData,pageNumber, rowsPage) {
  filterData.userId = '';
  let formattedStartDate = '';
  let formattedEndDate = '';
  let paymentType = '';
  if(filterData.merchantID == '') {
    filterData.userId = filterData.agentID
  }
  if(filterData.agentID == '') {
    filterData.userId = filterData.merchantID
  }
  if(filterData.start_date) {
    const startDate = filterData.start_date; 
    const parts = startDate.split('-');
    formattedStartDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  if(filterData.end_date) {
    const startDate = filterData.end_date; 
    const parts = startDate.split('-');
    formattedEndDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  if(filterData.paymentType) {
    paymentType = filterData.paymentType.toUpperCase();
  }
  
  return axios.get(`${baseURL}/transaction/history?fromDate=${formattedStartDate}&toDate=${formattedEndDate}&transactionType=${paymentType}&userId=${filterData.userId}&page=${pageNumber}&size=${rowsPage}&status=RAISED`);
}

approveRejectTxn(body,id) {
  return axios.post(`${baseURL}/raised-txn/${id}/approve-reject?${this.time}`,body);

}
getSystemTransaction(body,pageNumber, rowsPage) {
  Object.keys(body).forEach(key => {
    // Check if the value is an empty string, convert to null
    if (body[key] === '') {
      body[key] = null;
    }
  })
  return axios.post(`${baseURL}/transaction/history/query?page=${pageNumber}&size=${rowsPage}`, body);
}

getTransactionStats(body) {
  Object.keys(body).forEach(key => {
    // Check if the value is an empty string, convert to null
    if (body[key] === '' || body[key] == null || body[key] == undefined) {
      body[key] = '';
    }
  })
  console.log(body)
  return axios.get(`${baseURL}/transaction/history/stats?advanced_search_key=${body.advanced_search_key}&advanced_search_value=${body.advanced_search_value}&fromDate=${body.from_date}&toDate=${body.to_date}&transactionType=${body.transaction_type}&paymentMethod=${body.payment_method}`);
}

downloadTransactionCSV(body) {
  return axios.post(`${baseURL}/transaction/history/download`, body, {
    responseType: 'blob'  // Specify the response type as blob (binary data)
  })
}


getSystemSummary(filters) {
  console.log(filters)
  let duration = "";
  let agentID = "";
  let customerID = "";
  let fromDate = "";
  let toDate = "";

  if(filters.duration) {
    duration = filters.duration
  }
  if(filters.agentID) {
    agentID = filters.agentID
  }
  if(filters.customerID) {
    customerID = filters.customerID
  }
  if(filters.from_date) {
    fromDate = duration == 'CUSTOM' ? filters.from_date : ''
  }
  if(filters.to_date) {
    toDate =  duration == 'CUSTOM' ? filters.to_date : ''
  }

  return axios.get(`${baseURL}/transactions/stat?duration=${duration}&agentId=${agentID}&customerId=${customerID}&startDate=${fromDate}&endDate=${toDate}`);

}

getSearchTransaction(){
  const token = JSON.parse(localStorage.getItem("searchTransaction"));
  return token;
}
setSearchTransaction(data,pageNo){
  data.pageNo = pageNo
  localStorage.setItem("searchTransaction", JSON.stringify(data));
}
getTopPerformers() {
  return axios.get(`${baseURL}/config/top-performers`);
}
getPayInAndPayoutStats(merchantId) {
  if(merchantId ==null) {
    merchantId = '';
  }
  return axios.get(`${baseURL}/transaction/history/stats/new?merchantId=${merchantId}`);

}

getTicketingStats() {
  return axios.get(`${baseURL}/tickets/stats`);

}

getOverAllDetails() {
  return axios.get(`${baseURL}/transactions/overall/details`);

}
getSuccessDetails(hours) {
  return axios.get(`${baseURL}/transactions/success-details?hours=${hours}`);

}
getActorsStats() {
  return axios.get(`${baseURL}/stats/actors`);
}

getTopTicketing(hours) {
  return axios.get(`${baseURL}/tickets/subject/stats`);
  }
  
  compareTransaction( data) {
    return axios.post(`${baseURL}/transactions/compare`, data);
}

}
export default new DashboardService();